import type {
  AddProjectMemberRequest,
  ProjectMember,
  UpdateProjectMemberRequest,
} from '@ledokol/contracts'
import { api } from './client'

/**
 * Эпик «Участники» (2026-06-09) — управление членами команды проекта.
 * Бэкенд автонаполняет project_member из TG-событий (вступление/первое сообщение),
 * этот клиент даёт admin/lead UI поверх того же эндпоинта: добавить вручную,
 * сменить роль, убрать. Soft-leave (`left_at`) — только через TG; через UI удаление
 * полное (hard-delete row).
 */

export async function listProjectMembers(projectId: string): Promise<ProjectMember[]> {
  const r = await api.get<ProjectMember[]>(`/projects/${projectId}/members`)
  return r.data
}

export async function addProjectMember(
  projectId: string,
  body: AddProjectMemberRequest,
): Promise<ProjectMember[]> {
  const r = await api.post<ProjectMember[]>(`/projects/${projectId}/members`, body)
  return r.data
}

export async function updateProjectMember(
  projectId: string,
  userId: string,
  body: UpdateProjectMemberRequest,
): Promise<ProjectMember[]> {
  const r = await api.patch<ProjectMember[]>(`/projects/${projectId}/members/${userId}`, body)
  return r.data
}

export async function removeProjectMember(projectId: string, userId: string): Promise<void> {
  await api.delete(`/projects/${projectId}/members/${userId}`)
}

/**
 * Синхронизация project_member из TG-чата по архивным draft'ам. Бекфилл через
 * findOrCreateStub + ensureMember. Идемпотент. Возвращает {scanned, ensured, stubsCreated}.
 */
export async function syncProjectMembersFromTg(projectId: string): Promise<{
  scanned: number
  ensured: number
  stubsCreated: number
}> {
  const r = await api.post<{ scanned: number; ensured: number; stubsCreated: number }>(
    `/projects/${projectId}/members/sync-tg`,
  )
  return r.data
}
